import React, { ChangeEvent } from "react";
import { TextField } from "@mui/material";
import customTextFieldStyle from "./customTextFieldStyle";

interface CustomTextFieldProps {
  maxWidth?: string;
  label: string;
  name: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const CustomTextField: React.FC<CustomTextFieldProps> = ({  maxWidth = "100%", label, name, value, onChange, disabled, error, helperText, onBlur }) => {
  return (
    <TextField
      fullWidth
      sx={{ maxWidth, ...customTextFieldStyle.textField }}
      margin="normal"
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
      variant="outlined"
      error={error}
      helperText={helperText}
      onBlur={onBlur}
    />
  );
};

export default CustomTextField;
